export default {"src":"/_next/static/media/attention-circle.7bf815ed.svg","height":24,"width":24};